import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'am-outstanding-promo',
  styleUrls: ['./outstanding-promo.component.scss'],
  templateUrl: './outstanding-promo.component.html',
})
export class OutstandingPromoComponent implements OnInit {
  @Input()
  public offer: any;

  constructor() {}

  public ngOnInit() {}
}
